module.exports = __webpack_public_path__ + "img/logo.2188377f.png";